/**
 * all actions for profile state
 *
 * Created by Min on 10/08/18
 */

import C from '../constants'

// action to hide/show the loader for the profile
export const showProfileLoader = booleanVal => {
    return {
        type: C.SET_PROFILE_LOADER,
        payload: booleanVal
    }
}

// action to edit the profile
export const editProfile = booleanVal => {
    return {
        type: C.EDIT_PROFILE,
        payload: booleanVal
    }
}

// action to set the profile data
export const setProfileData = objectVal => {
    return {
        type: C.SET_PROFILE_DATA,
        payload: objectVal
    }
}


/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the profile saga (sagas/profile.js)
export const getProfileData = () => {
    return {
        type: C.FETCH_PROFILE_DATA,
    }
}

// call the action to update the profile
// NOTE: this will be picked up by the profile saga (sagas/profile.js)
export const updateProfileRequest = objectVal => {
    return {
        type: C.UPDATE_PROFILE,
        payload: objectVal
    }
}



// WEBPACK FOOTER //
// ./src/actions/profileActions.js